/**
 * Confettis de victoire (visuel seul). Repris du prototype (index.html:336-353).
 * Coupés en mouvement réduit (F-SETTINGS-003, docs/05 §2.5) ; le carillon et l'haptique de
 * victoire, eux, sont déclenchés indépendamment par `main.ts` (non concernés par le motion).
 */
import { isMotionReduced } from '../settings';

interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  g: number;
  s: number;
  c: string;
  r: number;
  vr: number;
  life: number;
}

let particles: Particle[] = [];
let raf: number | null = null;
let fxCanvas: HTMLCanvasElement | null = null;
let fxCtx: CanvasRenderingContext2D | null = null;

const R = (n: number): number => Math.floor(Math.random() * n);

function ensure(): boolean {
  if (!fxCanvas) {
    fxCanvas = document.getElementById('fx') as HTMLCanvasElement | null;
    fxCtx = fxCanvas?.getContext('2d') ?? null;
  }
  return !!(fxCanvas && fxCtx);
}

export function confetti(cols: string[]): void {
  if (isMotionReduced()) return; // motion réduit : pas de confettis (le statut « pop » suffit)
  if (!ensure() || !fxCanvas || !fxCtx) return;
  fxCanvas.width = window.innerWidth;
  fxCanvas.height = window.innerHeight;
  for (let i = 0; i < 110; i++) {
    particles.push({
      x: window.innerWidth / 2 + (Math.random() - 0.5) * 160,
      y: window.innerHeight * 0.45,
      vx: (Math.random() - 0.5) * 9,
      vy: -4 - Math.random() * 7,
      g: 0.22 + Math.random() * 0.1,
      s: 4 + Math.random() * 5,
      c: cols[R(cols.length)],
      r: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.3,
      life: 70 + R(40),
    });
  }
  if (raf === null) tick();
}

function tick(): void {
  if (!fxCanvas || !fxCtx) return;
  const c = fxCanvas;
  const x = fxCtx;
  x.clearRect(0, 0, c.width, c.height);
  particles = particles.filter((p) => p.life-- > 0);
  for (const p of particles) {
    p.x += p.vx;
    p.y += p.vy;
    p.vy += p.g;
    p.r += p.vr;
    x.save();
    x.translate(p.x, p.y);
    x.rotate(p.r);
    x.fillStyle = p.c;
    x.globalAlpha = Math.min(1, p.life / 30);
    x.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
    x.restore();
  }
  if (particles.length) {
    raf = requestAnimationFrame(tick);
  } else {
    raf = null;
    x.clearRect(0, 0, c.width, c.height);
  }
}
